'use strict';

var sink = function sink() {};

var _match = function _match(either, patterns) {
  return either.fold(patterns.Error || sink, patterns.Ok || sink);
};

var left = function left(value) {
  return {
    map: function map(fn) {
      return this;
    },
    fold: function fold(f, g) {
      return f(value);
    },
    chain: function chain(fn) {
      return this;
    },
    match: function match(patterns) {
      return _match(this, patterns);
    },

    value: value
  };
};

var right = function right(value) {
  return {
    map: function map(fn) {
      return Right(fn(value));
    },
    fold: function fold(f, g) {
      return g(value);
    },
    chain: function chain(fn) {
      return fn(value);
    },
    match: function match(patterns) {
      return _match(this, patterns);
    },

    value: value
  };
};

var Left = function Left(value) {
  return Object.assign(Object.create(null), left(value));
};
var Right = function Right(value) {
  return Object.assign(Object.create(null), right(value));
};

var sequence = function sequence(eitherList) {
  return eitherList.reduce(function (acc, either) {
    return acc.chain(function (list) {
      return either.map(function (value) {
        return list.concat(value);
      });
    });
  }, Right([]));
};

var try_ = function try_(fn) {
  try {
    return Right(fn());
  } catch (e) {
    return Left(e);
  }
};

var Either = {
  Left: Left,
  Right: Right
};

module.exports.Either = Either;
module.exports.sequence = sequence;
module.exports.try_ = try_;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/utils/either.js
// module id = 202
// module chunks = 0